
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/epaper/tai-po-fire-tragedy-e-paper-collection",
      function () {
        return require("private-next-pages/epaper/tai-po-fire-tragedy-e-paper-collection/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/epaper/tai-po-fire-tragedy-e-paper-collection"])
      });
    }
  